<template>
    <ai-popup
        ref="popupRef"
        title="Добавление областей использования в роль"
        width="80vw"
        height="80vh"
        :bottom-buttons-enabled="true"
        first-button-text="Выбрать"
        v-model:visible="state.areaPopupVisible"
        @submit-click="addSelection"
        @close-popup="closePopup"
    >
        <local-tree-list ref="areaTreeListRef" :data-source="displayList" :meta="meta">
            <template #toolbarItems>
                <dx-item location="before">
                    Выбор приложения для фильтрации областей использования:
                </dx-item>
                <dx-item location="before">
                    <dx-select-box
                        :data-source="displayApps"
                        value-expr="kod_app"
                        display-expr="name_app"
                        :value="app"
                        width="300px"
                        @value-changed="valueChangedSelectBox"
                    />
                </dx-item>
            </template>
            <template #icon="{ data }">
                <div class="flex">
                    <img
                        v-if="!data.data.leaf"
                        class="w-[17px] mr-2"
                        src="../../../../public/assets/group-area.svg"
                        width="17px"
                    />

                    <img v-else class="w-[17px] mr-2" src="../../../../public/assets/area.svg" width="17px" />
                    <div>{{ data.data.name }}</div>
                </div>
            </template>
        </local-tree-list>
    </ai-popup>
</template>

<script setup>import { ref, onMounted, computed } from 'vue';
import { DxSelectBox } from 'devextreme-vue';
import { DxItem } from 'devextreme-vue/tree-list';
import AiPopup from '@/components/ai-popup/ai-popup.vue';
import LocalTreeList from '@/components/local-tree-list.vue';
import roleLocalStore from '@/views/administration/roles/store.js';
import rolesStore from '@/store/administration/roles.js';
import environmentStore from '@/store/enviroment-data.js';

const { state } = roleLocalStore;
const { rolesState, getAreaListByAppKod, getAreaList } = rolesStore;

const popupRef = ref();
const areaTreeListRef = ref();
const treeListInstance = ref();
const app = ref(state.formData.appId);
const group = ref([]);
const areas = ref([]);

const displayList = computed(() => [...group.value, ...areas.value]);
const displayApps = computed(() => [{ kod_app: 'all', name_app: 'Все области' }, ...environmentStore.state.appList]);

onMounted(async () => {
    treeListInstance.value = areaTreeListRef.value.treeListInstance;
    treeListInstance.value.on('editorPrepared', editorPrepared);
    await getAreaListByAppKod(app.value, false);
    await getAreaList();
    await onShown();
});

const onShown = async () => {
    await areasFilter();
    setTimeout(() => {
        areaTreeListRef.value.collapseAll();
        treeListInstance.value.clearSelection();
    }, 1);
    const selectedRowKeys = state.areas.map(area => area.displayId);
    if (selectedRowKeys.length > 0) {
        setTimeout(() => treeListInstance.value.selectRows(selectedRowKeys, true), 1);
    }
};

const editorPrepared = event => {
    if (event.parentType === 'dataRow' && event.row.data.isGroup) {
        event.cancel = true;
        event.editorElement.style.display = 'none';
    }
};

const closePopup = () => {
    state.areaPopupVisible = false;
    state.rolePopupVisible = true;
};

const valueChangedSelectBox = async event => {
    app.value = event.value;
    await areasFilter();
};

const areasFilter = async () => {
    const parents = [];
    const appParam = app.value === 'all' ? null : app.value;
    await getAreaListByAppKod(appParam, false);
    group.value = rolesState.areaListByAppKod?.map(g => {
        parents.push(g.id);
        return {
            ...g,
            displayId: g.id,
            leaf: false,
        };
    });

    areas.value = rolesState.areaList
        .filter(area => parents.includes(area.group_id) || area.group_id === null)
        .map(area => ({
            ...area,
            parent_id: area.group_id,
            displayId: `${area.id}:a`,
            leaf: true,
        }));
};

const addSelection = () => {
    const selectedRowsData = treeListInstance.value.getSelectedRowsData('all');
    const selectedAreas = selectedRowsData
        .filter(row => row.leaf && !roleLocalStore.state.areas.some(area => area.id === row.id))
        .map(row => ({
            ...row,
            permission: 'R',
            app_id: state.formData.appId,
        }));
    if (selectedAreas.length) {
        roleLocalStore.addAreas(selectedAreas);
    }
    closePopup();
};

const meta = {
    title: 'Выберите области использования',
    keyExpr: 'displayId',
    parentIdExpr: 'parent_id',
    rootValue: 'null',
    scrollingMode: 'standart',
    allowSelectAll: true,
    recursiveSelection: true,
    columns: [
        {
            dataField: 'name',
            caption: 'Область использования',
            cellTemplate: 'icon',
        },
        {
            dataField: 'description',
            caption: 'Описание',
        },
    ],
};
</script>
